import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import App from './App';
import './scss/App.scss';

const container = document.getElementById('root');

// react-snap génère un HTML pré-rendu : on hydrate au lieu de re-render.
if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
